import React from "react";
import { useApp } from "../context/AppContext";
import { useBrand } from "../context/BrandContext";
import { Truck, Factory, Store, LayoutDashboard, Boxes, LogOut } from "lucide-react";

const ROLES = [
  { key: "client", label: "Client", icon: Store, accent: "bg-primary" },
  { key: "usine", label: "Usine", icon: Factory, accent: "bg-blue-600" },
  { key: "transporteur", label: "Transporteur", icon: Truck, accent: "bg-secondary" },
  { key: "admin", label: "Admin", icon: LayoutDashboard, accent: "bg-purple-600" },
];

export const Header = () => {
  const { role, setRole, staffToken, logoutStaff } = useApp();
  const brand = useBrand();
  const current = ROLES.find((r) => r.key === role) || ROLES[0];
  const staffRole = ["usine", "transporteur", "admin"].includes(role);
  return (
    <header className="sticky top-0 z-40 border-b border-border bg-background/90 backdrop-blur-md">
      <div className={`h-0.5 w-full ${current.accent} transition-colors`} />
      <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <div className="flex items-center gap-2.5" data-testid="app-brand">
          {brand.logo_url && (
            <div className="flex h-10 w-10 items-center justify-center overflow-hidden rounded-md bg-white ring-1 ring-border">
              <img src={brand.logo_url} alt={brand.name} className="h-full w-full object-contain" />
            </div>
          )}
          <div className="leading-tight">
            <span className="font-display text-lg font-extrabold tracking-tight">{brand.name}</span>
            {brand.tagline && (
              <span className="hidden text-[11px] uppercase tracking-[0.2em] text-muted-foreground sm:block">
                {brand.tagline}
              </span>
            )}
          </div>
        </div>

        <div className="flex items-center gap-2">
        <nav className="flex items-center gap-1 rounded-lg border border-border bg-muted/40 p-1" data-testid="role-switcher">
          {ROLES.map((r) => {
            const Icon = r.icon;
            const active = role === r.key;
            return (
              <button
                key={r.key}
                data-testid={`role-btn-${r.key}`}
                onClick={() => setRole(r.key)}
                className={`flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-sm font-medium transition-colors sm:px-3.5 ${
                  active
                    ? "bg-background text-foreground shadow-sm ring-1 ring-border"
                    : "text-muted-foreground hover:text-foreground"
                }`}
              >
                <Icon className="h-4 w-4" />
                <span className="hidden sm:inline">{r.label}</span>
              </button>
            );
          })}
        </nav>
        {staffRole && staffToken && (
          <button
            data-testid="logout-btn"
            onClick={logoutStaff}
            className="flex items-center gap-1.5 rounded-md border border-border px-2.5 py-1.5 text-sm text-muted-foreground transition-colors hover:text-destructive"
            title="Se déconnecter"
          >
            <LogOut className="h-4 w-4" />
            <span className="hidden sm:inline">Quitter</span>
          </button>
        )}
        </div>
      </div>
    </header>
  );
};
